angular.module 'zc.projects'

.service 'campaignStatusTexts', ($filter) ->
  incomplete: $filter('translate')('projectsCampaigns.campaignCheckStatus.incomplete')
  preview: $filter('translate')('projectsCampaigns.campaignCheckStatus.preview')
  active: $filter('translate')('projectsCampaigns.campaignCheckStatus.active')
  finished: $filter('translate')('projectsCampaigns.campaignCheckStatus.finished')
  terminated: $filter('translate')('projectsCampaigns.campaignCheckStatus.terminated')
  pending: $filter('translate')('projectsCampaigns.campaignCheckStatus.pending')
  blocked: $filter('translate')('projectsCampaigns.campaignCheckStatus.blocked')



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/campaign_status_texts.constant.coffee